<template>
    <a-card v-if="pageLoading">
        <a-spin
        tip="Your document is being processed, do not leave this page!"
        :spinning="pageLoading"
        />
    </a-card>
    <a-form :form="baseform" v-else>
        <a-row :gutter="16">
            <a-col :xs="{span: 24}" :lg="{span:12}">
                <a-form-item  label="Kode Anggaran">
                    <a-tree-select
                            v-decorator="['kode_anggaran', {rules: [{required: true}], initialValue: editData.id_anggaran}]"
                            show-search
                            style="width: 100%"
                            @select="handlechoiceCost"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            :tree-data="anggaran.tree"
                            treeNodeFilterProp="children"
                            :filterTreeNode="filterTreeNode"
                            placeholder="Please select"
                            allow-clear
                            :disabled="mode ==='Edit'? editData.pemakaian>0?true:false :anggaran.loadingtree"
                            tree-default-expand-all
                    >
                    <template #suffixIcon><a-icon 
                        :type="mode ==='Edit'? (editData.pemakaian>0? 'loading' : 'down') 
                            : (anggaran.loadingtree ? 'loading' : 'down') " /></template>
            <span slot="title" slot-scope="item">
              <table style="width:100%">
                <tr>
                  <td>
                    <span> {{item.texttitle}} - {{item.kode_anggaran}}</span>
                  </td>
                  <td>
                    <span style="float:right"> {{formatRupiah(parseFloat(item.rekap))}} </span>
                  </td>
                </tr>
              </table>
            </span>
                    </a-tree-select>
                </a-form-item>
                <a-form-item label="Activity Name">
                    <a-input autocomplete="off" v-decorator="['item_detail', {rules: [{required: true}], initialValue: editData.item_detail}]"></a-input>
                </a-form-item>
                <a-form-item label="Value">
                    <a-input-number
                    :min="0"
                    class="m-text-numberRight  m-width-full"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    @keydown="onlyNumber"
                    v-decorator="['nilai', { rules: [{ required: true, message:'value is required!' }], initialValue: editData.nilai }]"
                    ></a-input-number>
                </a-form-item>
                <a-form-item>
                    <template #label>
                        <a-checkbox :defaultChecked="needBailoutFund" @change="onchangeNeedBailoutFund" :checked="needBailoutFund" >Need Bailout Fund (IDR)</a-checkbox>
                    </template>
                    <a-input-number
                        v-if="needBailoutFund"
                        :min="0"
                        class="m-width-full m-text-align-right"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\\s?|(,*)/g, '')"
                        v-decorator="['bailout_value', {rules: [{required: needBailoutFund ? true : false}], initialValue: editData.bailout_value}]"
                    />
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                    <a-button-group class="m-width-full">
                        <a-button @click="handleNewItemConfirm" block type="primary" html-type="submit">{{JSON.stringify(this.editData) === '{}' ? 'Add':'Update'}}</a-button>
                        <a-button v-if="mode_edit_dtl.status" @click="handlecancelEditDtl" block type="danger" >Cancel</a-button>
                    </a-button-group>
                </a-form-item>
            </a-col>
            <a-col :xs="{span: 24}" :lg="{span:12}">
                <a-collapse class="margin-top" activeKey="1">

                    <a-collapse-panel key="1">
                        <h4 slot="header" class="margin-remove">Activity List</h4>
                        <a-table v-if="!getScreen" :columns="columns" :dataSource="getCountWeb" :pagination="pagination" rowKey="no" size="small"  bordered :scroll="{ x: 100 }">
                            <template slot="item_nm" slot-scope="item_nm">
                                <span>{{item_nm.item_detail}}</span><br/>
                                <b>{{item_nm.kode_anggaran}}</b>
                            </template>
                            <template slot="val" slot-scope="items">
                                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="items.nilai" />
                            </template>
                            <template slot="operation" slot-scope="item">
                                <div style="text-align:center">
                                    <a-button-group v-if="item">
                                        <a-button type="primary"  @click="handleEditModal(item)" 
                                            :disabled="mode_edit_dtl.status"
                                        >
                                            <a-icon type="edit"/>
                                        </a-button>
                                        <a-button type="danger" @click="handleRemoveConfirm(item)" 
                                            :disabled="item.pemakaian>0 || mode_edit_dtl.status">
                                            <a-icon type="close"/>
                                        </a-button>
                                    </a-button-group>
                                </div>
                            </template>
                        </a-table>

                        <a-list itemLayout="vertical" :dataSource="listPembelian" :pagination="pagination" v-else>
                            <Empty v-if="listPembelian ? listPembelian.length<=0 : listPembelian"/>
                            <a-list-item slot="renderItem" slot-scope="item">
                                <a-list-item-meta>
                                    <a-row slot="title" type="flex" justify="space-between">
                                        <a href="#">{{item.item_detail}}</a>
                                    </a-row>
                                    <p slot="description">
                                    <ul class="m-list-wrapper">
                                        <h3 class="margin-remove" >{{item.kode_anggaran}}</h3>
<!--                                        <div class="m-display-flex space-between">-->
<!--                                            <span>{{item.kode_anggaran}}</span>-->

<!--                                        </div>-->
<!--                                        <a-divider class="margin-small" />-->
<!--                                        <h4 class="margin-remove m-text-align right">{{formatCurrency(mata_uang,item.oldvalue)}}</h4>-->
                                    </ul>
                                    </p>
                                </a-list-item-meta>

                                <a-button-group>
                                    <a-button type="primary" @click="handleEditModal(item)">
                                        <a-icon type="edit" />&nbsp;Edit
                                    </a-button>
                                    <a-button type="danger" @click="handleRemoveConfirm(item)">
                                        <a-icon type="close" />&nbsp; Remove
                                    </a-button>
                                </a-button-group>
                            </a-list-item>
                        </a-list>

                    </a-collapse-panel>
                </a-collapse>
                <div class="m-price-total">
                    <div v-if="totalBailout>0">
                        <span class="m-list-title">
                            Total Bailout :
                            {{
                            formatRupiah(totalBailout, "IDR" )
                            }}
                        </span>
                        <a-divider class="margin-small" />
                    </div>
                    <a-statistic title="Grand Total" :value="formatCurrency(mata_uang,totalPrice)" class="m-text-align right" />
                </div>
            </a-col>
        </a-row>
    </a-form>
</template>

<script>
    import { mapGetters } from "vuex";
    import axios from "axios";
    import CurrencyFormat from "@/mixins/CurrencyFormat";
    import GlobalMethod from "@/mixins/GlobalMethod.js";
    // import _ from "lodash";

    export default {
        name: "DetailPembelian",
        mixins: [CurrencyFormat, GlobalMethod],
        props: {
            id: String,
            data:{},
            listPembelian: {},
            informasi:{},
            infoUmum:{},
            keuangan:{},
            mode: String,
            mata_uang: String
        },
        data() {
            return {
                editModal: false,
                pagination: {
                    onChange: page => {},
                    pageSize: 5,
                    size: "small"
                },
                satuan: [],
                editData: {},
                anggaran: {
                    modalvalue: undefined,
                    path:"",
                    limit: 0,
                    tree: [],
                    searchValue: "",
                    loadingtree: false,
                },
                convert_value: 0,
                modalconvert_value: 0,
                pageLoading: true,
                needBailoutFund: false,
                mode_edit_dtl: {
                    status: false,
                    no: null
                }
            };
        },
        beforeCreate() {
            this.baseform = this.$form.createForm(this);
            this.modalForm = this.$form.createForm(this);
        },
        created(){
            this.getTreeAnggaran()
        },
        computed: {
            ...mapGetters(["getScreen", "getSatuan","getAuth", "getBailoutValue"]),
            initialData() {
                if (this.listPembelian === undefined || this.listPembelian.length <= 0) {
                    return {
                        nama_barang: "",
                        jumlah: 0,
                        satuan: "",
                        harga: 0,
                        path:"",
                        id_anggaran:"",
                        kode_anggaran:"",
                        kode_anggaran_dtl:"",
                        nilai: null
                    };
                } else {
                    return {
                        nama_barang: this.listPembelian.nama_barang,
                        jumlah: this.listPembelian.jumlah,
                        satuan: this.listPembelian.satuan,
                        harga: this.listPembelian.harga,
                        path: this.listPembelian.path,
                        id_anggaran: this.listPembelian.id_anggaran,
                        kode_anggaran: this.listPembelian.kode_anggaran,
                        kode_anggaran_dtl: this.listPembelian.kode_anggaran_dtl,
                        nilai: this.listPembelian.nilai
                    };
                }
            },
            initialList() {
                let outputList = [];
                if (this.listPembelian.length >= 1) {
                    outputList = this.listPembelian;
                }

                return outputList;
            },
            totalPrice() {
                let total = 0;
                this.listPembelian.forEach(item => {
                    total = total + item.nilai;
                });

                return total;
            },
            totalBailout() {
                let total = 0;
                this.listPembelian.forEach((item) => {
                    total = total + item.bailout_value;
                });

                return total;
            },
            initialSatuan() {
                let satuan = [];
                this.getSatuan.forEach(item => {
                    satuan.push(item["id"]);
                });

                return satuan;
            },
            columns() {
                const kolom = [
                    {
                        title: "No",
                        dataIndex: "no",
                        key: "no",
                        align: "right",
                        width: "60px",
                        sorter: (a, b) => a.no - b.no,

                    },
                    {
                        title: "Activity Name",
                        scopedSlots: { customRender: 'item_nm' },
                        key:"item_detail",
                        width: "250px",

                    },
                    {
                        title: "Value",
                        scopedSlots: { customRender: 'val' },
                        key:"val",
                        width: "150px",

                    },
                    {
                        title: "Bailout Value",
                        dataIndex: "bailout",
                        key: "bailout",
                        width: 100,
                        align: 'right'
                    },
                    {
                        title: 'Action',
                        scopedSlots: { customRender: 'operation' },
                        width: "120px",
                        fixed: "right"
                    },
                ];
                return kolom;
            },
            getCountWeb() {
                let data = this.listPembelian;

                if (this.listPembelian) {
                    // this.recountingAnggaran(this.listPembelian)
                    data.forEach((value, index) => {
                        data[index]['path'] = value.path ;
                        data[index]['kode_anggaran'] = value.kode_anggaran ;
                        // data[index]['kode_anggaran_dtl'] = value.values.kode_anggaran_dtl ;
                        // data[index]['pemakaian'] = value.values.pemakaian ;
                        // data[index]['id_anggaran'] = value.values.id_anggaran ;
                        data[index]['item_detail'] = value.item_detail ;
                        data[index]['value'] = this.formatCurrency(this.mata_uang, value.oldvalue);
                        data[index]['id_anggaran'] = value.id_anggaran;
                        data[index]['nilai'] = value.nilai;
                        // data[index]['quantity'] = value.values.jumlah+' '+value.values.satuan;
                        // data[index]['unit_price'] = this.formatCurrency(this.mata_uang, value.values.harga);
                        data[index]['bailout'] = this.formatCurrency('IDR', value.bailout_value ? value.bailout_value : 0);
                        data[index]['no'] = index+1;
                        // data[index]['key'] = index+1;
                    });
                }
                return data;
            }
        },
        methods: {
            convertingqty(val){
                let vinput = this.baseform.getFieldsValue();
                let tot = (val ? val : vinput.jumlah) * vinput.harga * this.keuangan.kurs_to_idr
                this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot)
            },
            convertinghrg(val){
                let vinput = this.baseform.getFieldsValue();
                let tot = vinput.jumlah * (val ? val : vinput.harga) * this.keuangan.kurs_to_idr
                this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot)
            },
            convertingmodalqty(val){
                let vinput = this.modalForm.getFieldsValue();
                let tot = (val ? val : vinput.jumlah) * vinput.harga * this.keuangan.kurs_to_idr
                this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot)
            },
            convertingmodalhrg(val){
                let vinput = this.modalForm.getFieldsValue();
                let tot = vinput.jumlah * (val ? val : vinput.harga) * this.keuangan.kurs_to_idr
                this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot)
            },
            handleClose(){
                this.convert_value = 0
                this.recountingAnggaran(this.listPembelian)
            },
            async getApproval(anggaran_id) {
                let params = {};
                if (this.mode=="Create"){
                    params = {
                        tlc : this.getAuth.username,
                        anggaran_dtl_val_id: anggaran_id,
                    };
                }else{
                    params = {
                        id_sppd: this.id,
                        tlc : this.getAuth.username,
                        anggaran_dtl_val_id: anggaran_id,
                    };
                }
                return await axios({
                    method: "get",
                    url: this.$serviceUrl + "sppds/approval_sppd",
                    params: params,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey,
                    },
                });
            },
            getTreeAnggaran(){
                this.anggaran.loadingtree = true
                let dataParams = this.mode == "Edit" ? {
                    sppd_id: this.id,
                    anggaran_id: this.informasi.cost_center,
                    tlc: this.getAuth.username,
                    peruntukan_id: this.informasi.peruntukan,
                } : {
                    anggaran_id: this.informasi.cost_center,
                    tlc: this.getAuth.username,
                    peruntukan_id: this.informasi.peruntukan
                }
                axios({
                    method: "get",
                    url: this.$serviceUrl + "sppds/tree_anggaran",
                    params: dataParams,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey,
                    },
                })
                    .then((response) => {
                        // if(this.mode=='Edit') {
                        //     let temptree1 = [...response.data.tree]
                        //     let temptree2 = [...temptree1,response.data.tree[0]]
                        //     this.listPembelian.forEach(elm => {
                        //         let ObjVal = elm.path.split(";")
                        //         let path1 = ""
                        //         let path2 = ""
                        //         ObjVal.forEach(element => {
                        //             if (path1==""){
                        //                 path1+="temptree1["+element+"]"
                        //                 path2+="temptree2["+element+"]"
                        //             }else{
                        //                 path1+=".children["+element+"]"
                        //                 path2+=".children["+element+"]"
                        //             }
                        //         });
                        //         // console.log(eval(path1+".origin_rekap"),Number(elm.nilai))
                        //         eval(path1+".origin_rekap="+path1+".origin_rekap+"+elm.nilai)
                        //         // console.log("j")
                        //         // eval(path2+".origin_rekap="+path2+".origin_rekap+"+elm.nilai)
                        //         // console.log("sas")
                        //     })
                        //     this.anggaran.tree = temptree1;
                        // } else{
                            // this.anggaran.tree = [...response.data.tree];
                            this.anggaran.tree = [...response.data.tree]
                            this.recountingAnggaran(this.listPembelian)
                        // }
                        
                        this.anggaran.loadingtree = false
                        this.pageLoading= false
                    })
                    .catch((err) => {
                        this.anggaran.loadingtree = false
                        let responses = Object.assign({}, err.response);
                        this.displayMessageValue("error", responses);
                    });
            },
            handlechoiceCost(value,record){
                this.anggaran.limit= record.dataRef.rekap
                this.anggaran.path = record.dataRef.path
            },
            handlechoiceCostModal(value,record){
                this.anggaran.limit= record.dataRef.rekap
                this.anggaran.path = record.dataRef.path
                this.anggaran.modalvalue = value
            },
            filterTreeNode(input, option) {
                return (
                    option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            handleSatuan(input, option) {
                return (
                    option.componentOptions.children[0].text
                        .toUpperCase()
                        .indexOf(input.toUpperCase()) >= 0
                );
            },

            handleNewItemConfirm(){
                if(JSON.stringify(this.editData) === '{}'){
                    this.handleNewItem()
                    // this.confirmMessageValue("confirm-add-detil",true);
                }else{
                    this.confirmMessageValue("confirm-edit-detil",true);
                }
            },
            handleNewItem() {
                this.baseform.validateFields((err, values) => {
                    if (err) {
                        this.displayMessage("form-warning");
                        return;
                    }
                    let ObjVal = this.anggaran.path.split(";")
                    let path = ""
                    ObjVal.forEach(element => {
                        if (path==""){
                            path+="tempTree["+element+"]"
                        }else{
                            path+=".children["+element+"]"
                        }
                    });
                    //
                    let tempTree = this.anggaran.tree
                    let limitasi = eval(path+".rekap")
                    let kdanggrn = eval(path+".kode_anggaran")
                    let kdanggrn2 = eval(path+".value")
                    let origin_rekap = eval(path+".origin_rekap")
                    
                    if(origin_rekap-values.nilai<0){
                        this.displayMessageValue("error-other", "value is over limit!");
                        return;
                    }

                    if(values.bailout_value && values.bailout_value>values.nilai){
                        this.displayMessageValue(
                        "error-other",
                        "Bailout value is over then value detail!"
                        );
                        return
                    }

                    let valEdited = 0
                    if(JSON.stringify(this.editData) != '{}'){
                        valEdited = this.editData.bailout_value
                    }

                    if(values.bailout_value && ((this.totalBailout-valEdited+values.bailout_value)>this.getBailoutValue)){
                        this.displayMessageValue(
                            "error-other",
                            "value is over limit of max. bailout value ("+this.formatRupiah(this.getBailoutValue)+")"
                        );
                        return
                    }

                        values.path = this.anggaran.path;
                        values.id_anggaran = values.kode_anggaran ;
                        values.kode_anggaran = kdanggrn;
                        values.kode_anggaran_dtl = kdanggrn2[kdanggrn2.length-1] ;
                        values.oldvalue = limitasi ;
                        values.id_sppd_dtl = null,
                        // values.item_detail = values.item_detail;
                        values.pemakaian = 0 ;


                    let findExist = this.listPembelian.filter(function (item) {
                        return item.kode_anggaran === values.kode_anggaran ;
                    });

                    if(JSON.stringify(this.editData) === '{}'){
                        //add
                        if(findExist.length > 0){
                            this.editData = {};
                            this.displayMessage("form-duplicate");
                            return;
                        }else{
                            Event.$emit("listPembelian", { values})
                            this.displayMessage("success-add");
                        }
                    }else{
                        //edit

                        if(findExist.length > 0){
                            if(findExist[0].pemakaian > 0){
                                let data = this.listPembelian;
                                let index = data.indexOf(this.editData);


                                if (index > -1) {
                                    data[index] = values;
                                    data[index].no = this.editData.no;
                                    data[index].pemakaian = this.editData.pemakaian;
                                    data[index].id_sppd_dtl = this.editData.id_sppd_dtl;
                                    data[index]['value'] = this.formatCurrency(this.mata_uang, values.oldvalue);
                                    data[index]['nilai'] = this.editData.nilai;

                                    Event.$emit("updateListXML", {data});
                                    this.editData = {};
                                    this.displayMessage("success-edit");
                                }
                            }else{
                                //
                                if(findExist[0].kode_anggaran === values.kode_anggaran){
                                        // if(this.editData.item_detail !== values.item_detail && this.editData.kode_anggaran === values.kode_anggaran) {
                                        if(this.editData.kode_anggaran === values.kode_anggaran) {
                                            let data = this.listPembelian;
                                            let index = data.indexOf(this.editData);
                                            if (index > -1) {
                                                data[index] = values;
                                                data[index].no = this.editData.no;
                                                data[index]['value'] = this.formatCurrency(this.mata_uang, values.oldvalue);

                                                Event.$emit("updateListXML", {data});
                                                this.editData = {};
                                                this.displayMessage("success-edit");
                                            }
                                            this.baseform.resetFields();
                                            this.convert_value = 0;
                                            this.mode_edit_dtl.status = false;
                                            return;
                                        }
                                    this.editData = {};
                                    this.displayMessage("form-duplicate");

                                }else{
                                    let data = this.listPembelian;
                                    let index = data.indexOf(this.editData);
                                    if (index > -1) {
                                        data[index] = values;
                                        data[index].no = this.editData.no;
                                        data[index]['value'] = this.formatCurrency(this.mata_uang, values.oldvalue);

                                        Event.$emit("updateListXML", {data});
                                        this.editData = {};
                                        this.displayMessage("success-edit");
                                        this.mode_edit_dtl.status = false;
                                    }
                                }

                            }
                        }else{
                            let data = this.listPembelian;
                            let index = data.indexOf(this.editData);

                            if (index > -1) {
                                data[index] = values;
                                data[index].no = this.editData.no;
                                data[index]['value'] = this.formatCurrency(this.mata_uang, values.oldvalue);

                                Event.$emit("updateListXML", {data});
                                this.editData = {};
                                this.displayMessage("success-edit");
                            }
                        }
                    }

                    this.baseform.resetFields();
                    this.convert_value = 0
                    
                    this.recountingAnggaran(this.listPembelian)
                });
            },
            handleRemoveConfirm(item) {
                this.confirmMessageValue("confirm-delete-detil",item);
            },
            handleRemove(item) {
                let index = this.listPembelian.indexOf(item);
                this.baseform.resetFields();
                this.editData= {};
                Event.$emit("deleteDetail", {index});

                //recounting 
                let temp = []
                item.nilai = 0
                temp.push(item)
                this.recountingAnggaran(this.listPembelian)
            },
            recountingAnggaran(arr){
                if(arr.length>0){
                    //restore nominal ke origin
                    arr.forEach(elm => {
                        let ObjVal = elm.path.split(";")
                        let path1 = ""
                        let path2 = ""
                        ObjVal.forEach(element => {
                            if (path1==""){
                                path1+="tempTree["+element+"]"
                            }else{
                                path1+=".children["+element+"]"
                            }
                        });
                        let tempTree = this.anggaran.tree
                        path2 = eval(path1+".origin_rekap")
                        eval(path1+".rekap="+path2)
                    })
                    //menghitung nominal dengan acuan nominal origin
                    arr.forEach(elem => {
                        let ObjVal = elem.path.split(";")
                        let path = ""
                        ObjVal.forEach(element => {
                            if (path==""){
                                path+="tempTree["+element+"]"
                            }else{
                                path+=".children["+element+"]"
                            }
                        });
                        let tempTree = this.anggaran.tree
                        let oldVal = eval(path+".rekap")
                        // path+=".rekap="+ (oldVal-(elem.values.harga*elem.values.jumlah)*1)
                        path+=".rekap="+ (oldVal-elem.nilai)
                        eval(path)
                        this.anggaran.tree = tempTree
                    });
                }
            },
            async handleEditModal(item) {
                this.baseform.resetFields();
                this.editData= item;
                this.anggaran.limit = item.oldvalue;
                this.anggaran.path = item.path;
                this.mode_edit_dtl.status = true

                if(this.editData.bailout_value && this.editData.bailout_value>0){
                    this.needBailoutFund = true
                }else{
                    this.needBailoutFund = false
                }

                let tempactivity = []
                for (let index = 0; index < this.listPembelian.length; index++) {
                    if(this.listPembelian[index].no==item.no) this.mode_edit_dtl.no=item.no;
                    let a = {
                        nilai: this.listPembelian[index].no==item.no ? 0 : this.listPembelian[index].nilai,
                        path: this.listPembelian[index].path
                    }
                    tempactivity.push(a)
                }
                await this.recountingAnggaran(tempactivity)
            },

            handleCancelEdit(){
                this.editData = {};
                this.baseform.resetFields();
                this.recountingAnggaran(this.listPembelian)
            },
            handleRef(){
                if(this.listPembelian.length > 0){
                    let anggaran_id = this.listPembelian[0].id_anggaran.split(';');

                    this.getApproval(anggaran_id[2]).then((res)=>{
                        Event.$emit("collectData",res.data.approval);
                    })
                }else{
                    this.displayMessage('Empty-list');
                }
            },
            onchangeNeedBailoutFund(val){
                this.needBailoutFund = val.target.checked
            },
            handlecancelEditDtl(){
                this.editData = {};
                this.mode_edit_dtl.status = false
                let tempactivity = []
                for (let index = 0; index < this.listPembelian.length; index++) {
                    let a = {
                        nilai: (this.mode_edit_dtl.no == this.listPembelian[index].no ? 0 : this.listPembelian[index].nilai),
                        path: this.listPembelian[index].path
                    }
                    tempactivity.push(a)
                }
                this.recountingAnggaran(tempactivity)
            }
        },
        watch:{
            listPembelian(){
                this.recountingAnggaran(this.listPembelian)
            }
        },
        mounted(){
            Event.$on("confirmMessageAddDetil", this.handleNewItem);
            Event.$on("confirmMessageDeleteDetil", this.handleRemove);
            Event.$on("confirmMessageEditDetil", this.handleNewItem);
            Event.$on("confirmMessageCancelEditDetil", this.handleCancelEdit);

        },
        beforeDestroy(){
            Event.$off("confirmMessageAddDetil", this.handleNewItem);
            Event.$off("confirmMessageDeleteDetil", this.handleRemove);
            Event.$off("confirmMessageEditDetil", this.handleNewItem);
            Event.$off("confirmMessageCancelEditDetil", this.handleCancelEdit);

        }
    };
</script>

<style>
</style>